
define('template!webshopAttributesProductInfoView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="header">\n    <img class="picture" src="' +
__e( image ) +
'" alt=""/>\n    <div class="title">\n        <div class="name">' +
__e( name ) +
'</div>\n        <div class="code">' +
__e( code ) +
'</div>\n        ';
 if (languages.length > 1) { ;
__p += '\n        <div class="langs">\n            ';
 _.each(languages, function (l) { ;
__p += '<span class="lang ';
 if (l === lang) { ;
__p += 'active';
 } ;
__p += '" data-lang="' +
((__t = ( l )) == null ? '' : __t) +
'">' +
((__t = ( l )) == null ? '' : __t) +
'</span>';
 }); ;
__p += '\n        </div>\n        ';
 } ;
__p += '\n    </div>\n</div>\n';
 if (images.length > 1) { ;
__p += '\n<div class="gallery">\n    ';
 _.each(images, function (src) { ;
__p += '<img src="' +
__e( src ) +
'" loading="lazy" alt=""/>';
 }); ;
__p += '\n</div>\n';
 } ;
__p += '\n<div class="section">\n    <div class="section-title">' +
((__t = ( _.i18n('attributeMatching.pimAttributes', null, 'PIM attributes') )) == null ? '' : __t) +
'</div>\n    <div class="pim-attributes"></div>\n</div>\n<div class="section">\n    <div class="section-title">' +
((__t = ( _.i18n('attributeMatching.productOptions', null, 'Options') )) == null ? '' : __t) +
'</div>\n    <div class="options"></div>\n</div>\n';
 if (sections.length === 0) { ;
__p += '\n<div class="empty">' +
((__t = ( _.i18n('attributeMatching.noWebshopText', null, 'No description in this language') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
 _.each(sections, function (s) { ;
__p += '\n<div class="section">\n    <div class="section-title">' +
((__t = ( s.title )) == null ? '' : __t) +
'</div>\n    <div class="section-body">' +
((__t = ( s.html )) == null ? '' : __t) +
'</div>\n</div>\n';
 }); ;
__p += '\n';

}
return __p
};});

